export default __webpack_public_path__ + "static/media/28.5c5ba955.png";